import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import CountryService from "./CountryDataService";

export const getCategories = createAsyncThunk(
  "category/getAllCat",
  async (thunkAPI) => {
    try {
      return await CountryService.getNewsCategories();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createNewNewsCat = createAsyncThunk(
  "category/addCategory",
  async (catData, thunkAPI) => {
    try {
      return await CountryService.createNewsCategory(catData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getANewsCat = createAsyncThunk(
  "category/getCat",
  
  async ({ id, cityId , subcollectionId }, thunkAPI) => {
    try {
      return await CountryService.getNewsCategory(id,cityId,subcollectionId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateANewsCat = createAsyncThunk(
  "category/editCategory",
  async ({ id, secondId ,subcollectionId , NewsCatData}, thunkAPI) => {
    try {
      return await CountryService.updateNewsCategory(id, secondId ,subcollectionId , NewsCatData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteANewsCat = createAsyncThunk(
  "category/deleteCategory",
  async ({  id, secondId, subcollectionId},thunkAPI) => {
    try {
      return await CountryService.deleteNewsCategory(id, secondId, subcollectionId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");
const initialState = {
  pCategorySlice: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const pCategorySlice = createSlice({
  name: "pCategorySlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.pCategorySlice = action.payload.data;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewNewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewNewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createNewsCategory = action.payload;
      })
      .addCase(createNewNewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.courseName = action.payload.data.courseName;
        state.courseDescription = action.payload.data.courseDescription;
        state.thumbnail = action.payload.data.thumbnail;
        state.websiteUrl = action.payload.data.websiteUrl;
        
      })
      .addCase(getANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedNewsCategory = action.payload;
      })
      .addCase(updateANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedNewsCategory = action.payload;
      })
      .addCase(deleteANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default pCategorySlice.reducer;
